import React, { Component } from 'react';
import './PersonRegist.css'
import Api from '../../api/wxapi';
import intl from 'react-intl-universal';
import Select from 'react-select';



//设备信息
export default class DeviceInfomation extends Component {
  constructor(props) {
    super();
    this.state = {
      deviceId: '',
      storename: '',
      storeadress: '',
      acount: '',
      time: ''

    };

  }

  componentDidMount() {
    document.title = '设备信息'
    this.getdata();
  }
  render() {
    let {
      deviceId,
      storename,
      storeadress,
      acount,
      time
    } = this.state

    return (
      <div className='flex-column-container' style={{ paddingLeft: 12, paddingRight: 12, flex: 1, marginTop: 12 ,backgroundColor:"#fff"}}>
        <div>
        <div className='flex-row-container' style={{justifyContent:"space-between",paddingTop:10,paddingBottom:10}}>
          <p>设备ID</p>
          <p> {deviceId}</p>
        </div>
         <p style={{flex:1,height:2,backgroundColor:'#F4F4F4',width:'100%'}}></p>
        </div> 

        <div>
        <div className='flex-row-container' style={{justifyContent:"space-between",paddingTop:10,paddingBottom:10}}>
          <p>门店名称</p>
          <p> {storename}</p>
        </div>
         <p style={{flex:1,height:2,backgroundColor:'#F4F4F4',width:'100%'}}></p>
        </div> 



        <div>
        <div className='flex-row-container' style={{justifyContent:"space-between",paddingTop:10,paddingBottom:10}}>
          <p>门店地址</p>
          <p> {storeadress}</p>
        </div>
         <p style={{flex:1,height:2,backgroundColor:'#F4F4F4',width:'100%'}}></p>
        </div> 


        <div>
        <div className='flex-row-container' style={{justifyContent:"space-between",paddingTop:10,paddingBottom:10}}>
          <p>绑定账号</p>
          <p> {acount}</p>
        </div>
         <p style={{flex:1,height:2,backgroundColor:'#F4F4F4',width:'100%'}}></p>
        </div> 

        
        <div>
        <div className='flex-row-container' style={{justifyContent:"space-between",paddingTop:10,paddingBottom:10}}>
          <p>创建时间</p>
          <p> {time}</p>
        </div>
         <p style={{flex:1,height:2,backgroundColor:'#F4F4F4',width:'100%'}}></p>
        </div> 
      </div>
    )
  }

  getdata() {

    Api.getDeviceInformation().then(res => {
      if (res.data.code == 0) {
        let data = res.data.data
        let time = data.create_time.split('T')
        this.setState({
          deviceId: data.number,
          storename: data.store_name,
          storeadress: data.store_address,
          acount: data.account,
          time: time[0]
        })

      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/views/person/DeviceInfomation.js